<style scpoed >

.top-margin {
    margin-left: 5px
}

</style>

<template>

<div>

    <el-row>

        <el-select v-model="formInline.moduleType" clearable @change="handleCurrentChange(1)" filterable placeholder="请选择业务类型">

            <el-option :value="1" label="开通会员"></el-option>
            <el-option :value="2" label="会员续费"></el-option>
            <el-option :value="3" label="升级经纪人"></el-option>
            <el-option :value="4" label="购买云服务"></el-option>
            <el-option :value="7" label="商品活动"></el-option>
            <el-option :value="8" label="智联车保"></el-option>
            <el-option :value="9" label="商家订单"></el-option>
            <el-option :value="10" label="云豆充值"></el-option>
            <el-option :value="11" label="省心加油"></el-option>
            <el-option :value="12" label="商家提现"></el-option>
            <el-option :value="13" label="经纪人提现"></el-option>
            <el-option :value="20" label="帖子置顶"></el-option>
            <el-option :value="21" label="二手车发布"></el-option>
            <el-option :value="22" label="二手车置顶"></el-option>
            <el-option :value="23" label="维保查询"></el-option>
            <el-option :value="24" label="碰撞查询"></el-option>
        </el-select>

        <el-date-picker type="datetimerange" v-model="formInline.startEndTime" start-placeholder="开始时间" placeholder="按发布时间筛选" end-placeholder="结束时间" @change="handleCurrentChange(1)">
        </el-date-picker>
        <el-input style="width:310px;" placeholder="输入业务单号" v-model="formInline.keyWord">
            <template slot="append">
                <el-button @click="handleCurrentChange(1)" type="primary">搜索</el-button>
            </template>
        </el-input>

    </el-row>

    <row>
        <div style="line-height: 30px;height: auto;margin-top: 10px;font-size: 20px;color: green;">收入：{{sumPlatIncome/100}}元，{{totalCount}}笔  </div>
    </row>

    <el-table :data="datas" class="basic-margin" style="width: 100%">
        <el-table-column label="记账时间">
            <template scope="scope">
               {{scope.row.payTime|dateTimeFormat}}
            </template>
        </el-table-column>

        <el-table-column label="业务订单号">
            <template scope="scope">
              <span style="color:#303133;">{{scope.row.payNumber}}</span>
            </template>
        </el-table-column>

        <el-table-column label="业务类型">
            <template scope="scope">
                <span>{{scope.row.moduleType|moduleTypeFilter}}</span>
            </template>
        </el-table-column>

        <el-table-column label="收入金额(元)">
            <template scope="scope">
                <span>{{scope.row.paltIncome/100}}</span>
            </template>
        </el-table-column>

    </el-table>
    <el-pagination class="row basic-margin" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
    </el-pagination>
</div>

</template>

<script>

import distributor from '@/framework/models/distributor'
import BasicPager from '../../mixins/BasicPager'
import DateUtil from '@/framework/utils/DateUtil'
export default {
  name: 'plat-income-management',
  extends: BasicPager,
  components: {
    distributor
  },
  data: function () {
    return {
      datas: [],
      sumPlatIncome: 0,
      formInline: {
        startEndTime: null,
        channelId: null,
        moduleType: null,
        keyWord: null
      },
      currentPage: 1, // 起始
      pageSize: 10, // 步长
      totalCount: 0, // 总条数
      dialogVisible: false,
      isAdmin: false

    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.formInline.channelId = userInfo.id
    this.formInline.startEndTime = [DateUtil.getDayStartTime(), DateUtil.getDayEndTime()]
    this.loadList()
  },
  activated: function () {

  },

  filters: {
    moduleTypeFilter (value) {
      let filterValue = '暂无'
      switch (value) {
        case 1:// 开通会员
          filterValue = '开通会员'
          break
        case 2:// 会员续费
          filterValue = '会员续费'
          break
        case 3:// 购买权益卡礼包
          filterValue = '升级经纪人'
          break
        case 4:// 续补权益卡
          filterValue = '购买云服务'
          break
        case 5:// 维保查询
          filterValue = '维保查询'
          break
        case 6:// 碰撞查询
          filterValue = '碰撞查询'
          break
        case 7:// 商品活动
          filterValue = '商品活动'
          break
        case 8:// 智联订单
          filterValue = '智联车保'
          break
        case 9:// 商品订单
          filterValue = '商品订单'
          break
        case 10:// 云豆充值
          filterValue = '云豆充值'
          break
        case 11:// 省心加油
          filterValue = '省心加油'
          break
        case 12:// 商家提现
          filterValue = '商家提现'
          break
        case 13:// 经纪人提现
          filterValue = '经纪人提现'
          break
        case 20:// 经纪人提现
          filterValue = '帖子置顶'
          break
        case 21:// 经纪人提现
          filterValue = '二手车发布'
          break
        case 22:// 经纪人提现
          filterValue = '二手车置顶'
          break
        case 23:// 经纪人提现
          filterValue = '维保查询'
          break
        case 24:// 经纪人提现
          filterValue = '碰撞查询'
          break
      }
      return filterValue
    }
  },
  methods: {

    handleSizeChange (val) { // 监听页数变化
      this.pageSize = val
      this.loadList()
    },
    handleCurrentChange (val) { // 监听页码变化
      this.currentPage = val
      this.loadList()
    },
    handleAddSuccess: function () {
      this.loadList()
    },
    handleEditSuccess: function () {
      this.loadList()
    },
    loadList: function () {
      let _this = this
      let params = {
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
        channelId: _this.formInline.channelId,
        moduleType: _this.formInline.moduleType,
        keyWord: _this.formInline.keyWord
      }

      if (_this.formInline.startEndTime && _this.formInline.startEndTime.length === 2) {
        let startTime = _this.formInline.startEndTime[0]
        let endTime = _this.formInline.startEndTime[1]
        if (startTime) {
          params.startTime = startTime.getTime()
        }
        if (endTime) {
          params.endTime = endTime.getTime()
        }
      }

      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data.list

          _this.sumPlatIncome = dataInfo.data.sumPlatIncome
          _this.totalCount = dataInfo.recordsTotal
        }
      }

      distributor.selectPlatIncomeList(this, params, listener)
    }
  }
}

</script>
